import React from 'react';
import './ModerationLayout.scss';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Header } from 'components/Header';
import { SidebarModeration } from 'components/SidebarModeration/SidebarModeration';
import { useSelector } from 'react-redux';
import { ELinksName } from 'services/constants/list-links-sidebar';
import { getIsAuth } from 'redux/reducers/auth/selectors';

export const ModerationLayout: React.FC = () => {
  const isAuth = useSelector(getIsAuth);
  const location = useLocation();

  if (!isAuth) return <Navigate to={ELinksName.LOGIN} state={{ from: location }} replace />;

  return (
    <div className="moderation-layout">
      <Header />
      <div className="moderation-layout__wrapper">
        <SidebarModeration />
        <div className="moderation-layout__main">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
